import { CommonModule } from '@angular/common';
import { CountryFlagPipe } from './country-flag.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule],
  declarations: [CountryFlagPipe],
  exports: [CountryFlagPipe],
})
export class CountryFlagModule {}
